var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"text-center"},[(_vm.hasPhotoCreateur)?_c('img',{staticClass:"avatar-md rounded-circle",attrs:{"src":_vm.photoCreateur}}):_c('i',{staticClass:"las la-user la-3x"}),_c('h6',[_vm._v(_vm._s(_vm.nameCreateur))]),_c('small',[_vm._v(_vm._s(_vm.titreCreateur))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }